(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-accordion"] && !Shopify.designMode) return;
  try {
    
  class BenefitsAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-scroll-to-offer]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector('.product-offer');
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.classList.add('is-animated');
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      this.querySelectorAll('[data-reveal]').forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('benefits-accordion')) customElements.define('benefits-accordion', BenefitsAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-stories-slider')) {
    customElements.define(
      'customer-stories-slider',
      class CustomerStoriesSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = this.querySelector('[data-dots]');
          this.querySelector('[data-prev]').addEventListener('click', () => this.go(-1));
          this.querySelector('[data-next]').addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.buildDots());
          this.resizeObserver.observe(this.track);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        get maxScroll() {
          return this.track.scrollWidth - this.track.clientWidth;
        }

        get pageCount() {
          return Math.max(1, Math.ceil(this.track.scrollWidth / this.track.clientWidth - 0.05));
        }

        get currentPage() {
          if (this.maxScroll <= 0) return 0;
          return Math.round((this.track.scrollLeft / this.maxScroll) * (this.pageCount - 1));
        }

        go(direction) {
          const max = this.maxScroll;
          if (direction > 0 && this.track.scrollLeft >= max - 2) {
            this.track.scrollTo({ left: 0 });
          } else if (direction < 0 && this.track.scrollLeft <= 2) {
            this.track.scrollTo({ left: max });
          } else {
            this.track.scrollBy({ left: direction * this.track.clientWidth });
          }
        }

        buildDots() {
          this.dots.replaceChildren();
          const count = this.pageCount;
          if (count > 1) {
            for (let i = 0; i < count; i++) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.setAttribute('aria-label', String(i + 1));
              dot.addEventListener('click', () => {
                this.track.scrollTo({ left: (this.maxScroll * i) / (count - 1) });
              });
              this.dots.append(dot);
            }
          }
          this.update();
        }

        update() {
          const current = this.currentPage;
          [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pain-points"] && !Shopify.designMode) return;
  try {
    
  class PainPoints extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this.classList.add('is-animated');
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      this.querySelectorAll('[data-reveal]').forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('pain-points')) customElements.define('pain-points', PainPoints);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('.product-offer__form input[name="id"]')) return;
    var root = input.closest('.product-offer');
    var compare = input.dataset.compare;
    root.querySelectorAll('[data-offer-price]').forEach(function (el) {
      el.textContent = input.dataset.price;
    });
    root.querySelectorAll('[data-offer-compare]').forEach(function (el) {
      el.textContent = compare;
      el.hidden = !compare;
    });
    var badge = root.querySelector('[data-offer-badge]');
    if (badge) {
      badge.hidden = !compare;
      badge.querySelector('[data-offer-percent]').textContent = input.dataset.percent;
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', input.value);
    history.replaceState(null, '', url);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.product-offer__form')) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    event.preventDefault();

    var button = form.querySelector('.product-offer__submit');
    var errorEl = form.querySelector('[data-offer-error]');
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.hidden = true;

    var addUrl = typeof Theme !== 'undefined' ? Theme.routes.cart_add_url : '/cart/add.js';
    var cartUrl = typeof Theme !== 'undefined' ? Theme.routes.cart_url : '/cart';

    var formData = new FormData(form);
    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
    });
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));
    var quantity = Number(formData.get('quantity')) || 1;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    // Adds the free gift once per cart when the chosen offer qualifies; the
    // automatic discount in Shopify admin is what makes it free.
    function addGift(response) {
      var giftInput = form.querySelector('[data-gift-variant]');
      var checked = form.querySelector('input[name="id"]:checked');
      if (response.status || !giftInput || !checked || !checked.hasAttribute('data-gift')) return response;
      var giftId = Number(giftInput.value);

      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (cartResponse) {
          return cartResponse.json();
        })
        .then(function (cart) {
          var hasGift = cart.items.some(function (item) {
            return item.variant_id === giftId;
          });
          if (hasGift) return response;

          return fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: giftId, quantity: 1 }], sections: sectionIds.join(',') }),
          })
            .then(function (giftResponse) {
              return giftResponse.json();
            })
            .then(function (giftResponse) {
              if (!giftResponse.status && giftResponse.sections) response.sections = giftResponse.sections;
              return response;
            });
        })
        .catch(function (error) {
          console.error(error);
          return response;
        });
    }

    import('@shopify/events')
      .catch(function (error) {
        console.error(error);
        button.removeAttribute('aria-busy');
        form.submit();
        return null;
      })
      .then(function (events) {
        if (!events) return;
        var deferred = events.CartLinesUpdateEvent.createPromise();

        form.dispatchEvent(
          new events.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(formData.get('id')), quantity: quantity }],
            promise: deferred.promise,
          })
        );

        return fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then(function (response) {
            return response.json();
          })
          .then(addGift)
          .then(function (response) {
            return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then(function (cartResponse) {
                return cartResponse.json();
              })
              .then(function (cart) {
                var didError = Boolean(response.status);
                deferred.resolve({
                  cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                  detail: {
                    items: cart.items,
                    source: 'product-offer',
                    itemCount: quantity,
                    productId: formData.get('product-id') || undefined,
                    sections: didError ? undefined : response.sections,
                    didError: didError,
                  },
                });

                if (didError) {
                  showError(response.description || response.message);
                  return;
                }

                requestAnimationFrame(function () {
                  if (!drawer.isOpen) drawer.open();
                });
              });
          })
          .catch(function (error) {
            console.error(error);
            deferred.reject(error);
            showError(button.dataset.errorMessage);
          });
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.product-offer__thumb');
    if (!thumb) return;
    var root = thumb.closest('.product-offer');
    var main = root.querySelector('#ProductOfferMain');
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = thumb.dataset.src;
    main.alt = thumb.dataset.alt;
    root.querySelectorAll('.product-offer__thumb').forEach(function (el) {
      el.classList.toggle('is-active', el === thumb);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function animate(el) {
      var match = el.dataset.countTarget.match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!match) return;
      var prefix = match[1];
      var raw = match[2];
      var suffix = match[3];
      var separator = raw.indexOf(',') > -1 ? ',' : '.';
      var decimals = raw.indexOf(separator) > -1 ? raw.split(separator)[1].length : 0;
      var target = parseFloat(raw.replace(',', '.'));
      var duration = 1800;
      var start = null;

      function step(now) {
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = (target * eased).toFixed(decimals).replace('.', separator);
        el.textContent = prefix + value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    function init(root) {
      var items = root.querySelectorAll('[data-count-up]:not([data-count-ready])');
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animate(entry.target);
        });
      }, { threshold: 0.4 });

      items.forEach(function (el) {
        el.setAttribute('data-count-ready', '');
        el.dataset.countTarget = el.textContent.trim();
        var match = el.dataset.countTarget.match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
        if (match) el.textContent = match[1] + '0' + match[3];
        observer.observe(el);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-slider')) {
    customElements.define(
      'testimonials-slider',
      class TestimonialsSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.dots = this.querySelector('[data-dots]');

          this.prev.addEventListener('click', () => this.go(-1));
          this.next.addEventListener('click', () => this.go(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.buildDots());
          this.resizeObserver.observe(this.track);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        get pageCount() {
          return Math.max(1, Math.ceil(this.track.scrollWidth / this.track.clientWidth - 0.05));
        }

        get currentPage() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          if (max <= 0) return 0;
          return Math.round((this.track.scrollLeft / max) * (this.pageCount - 1));
        }

        go(direction) {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const atEnd = this.track.scrollLeft >= max - 2;
          const atStart = this.track.scrollLeft <= 2;

          if (direction > 0 && atEnd) {
            this.track.scrollTo({ left: 0 });
          } else if (direction < 0 && atStart) {
            this.track.scrollTo({ left: max });
          } else {
            this.track.scrollBy({ left: direction * this.track.clientWidth });
          }
        }

        buildDots() {
          this.dots.replaceChildren();
          const count = this.pageCount;
          if (count > 1) {
            for (let i = 0; i < count; i++) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.setAttribute('aria-label', String(i + 1));
              dot.addEventListener('click', () => {
                const max = this.track.scrollWidth - this.track.clientWidth;
                this.track.scrollTo({ left: count > 1 ? (max * i) / (count - 1) : 0 });
              });
              this.dots.append(dot);
            }
          }
          this.update();
        }

        update() {
          const current = this.currentPage;
          [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["week-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lists = [];
    var ticking = false;

    function update() {
      ticking = false;
      var anchor = window.innerHeight * 0.7;
      lists.forEach(function (list) {
        var rect = list.getBoundingClientRect();
        var start = rect.top + 21;
        var length = Math.max(rect.height - 33, 1);
        var progress = Math.min(Math.max((anchor - start) / length, 0), 1);
        list.style.setProperty('--timeline-fill', progress.toFixed(4));
        list.querySelectorAll('.week-timeline__stage').forEach(function (stage) {
          var dot = stage.getBoundingClientRect().top + 21;
          stage.classList.toggle('is-reached', dot <= anchor);
        });
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function init() {
      lists = Array.prototype.slice.call(document.querySelectorAll('[data-timeline-progress]'));
      lists.forEach(function (list) {
        list.setAttribute('data-progress-ready', '');
      });
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('load', requestUpdate);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
